import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const SearchComponent = ({heading}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const [debounceTimer, setDebounceTimer] = React.useState(null);

  const handleInputChange = (event) => {
    const value = event.target.value;

    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    const timer = setTimeout(() => {
      if (value) {
        navigate(`${pathname}?search=${value}`);
      } else {
        navigate(pathname);
      }
    }, 1000);

    setDebounceTimer(timer);
  };

  return (
    <div className="">
      <input
        type="text"
        className="form-control"
        placeholder={`Search ${heading}...`}
        onChange={handleInputChange}
      />
    </div>
  );
};

export default SearchComponent;
